import React from 'react';
import './Progress.css';

class Progress extends React.Component {
  render() {
    const items = this.props.data.map((item, i) => {
      return (
        <div className="progress-item" key={i}>
          <h3 className="progress-item-title">{item.title}</h3>
          
          {item.summary.map(function (name, j) {
            return <div className="progress-item-tag" key={j}>{name}</div>;
          })}
        </div>
      )
    });

    return <div className="progress">{items}</div>;
  }
}

export default Progress;



// WEBPACK FOOTER //
// ./src/Shared/Progress.js